<template>
	<form
		:class="[
			'styled-form',
			'styled-form--white-box',
			{'is-loading': isLoading}
		]"
		@submit.prevent="onSubmit"
	>

		<div v-if="isLoading" class="styled-form__overlay">
			<div class="preloader"></div>
		</div>

		<global-message v-if="errors.global" :value="errors.global"></global-message>

        <div class="styled-form__header">
            <h2 class="styled-form__title">Resend your verification code</h2>

            <h3 class="styled-form__subtitle">Please enter the email address of your registration below.</h3>
        </div>

        <div class="styled-form__corset">

            <form-input
                    v-model="data.email"
                    name="email"
                    label="Email Address *"
                    :error="errors.email"
                    class="to-lower-case"
            ></form-input>

        </div>

        <div class="styled-form__v-rhythm text--center">
            <a
                    class="btn btn--secondary"
                    :disabled="isLoading"
                    @click.prevent="cancel"
            >Cancel</a>
            <button class="btn" :disabled="isLoading">Continue</button>
        </div>

	</form>
</template>

<script>
	import isEmail from '../../helpers/isEmail';
	import GlobalMessage from '../messages/GlobalMessage.vue';
	import FormInput from '../formFields/FormInput.vue';

	export default {
		components: {
			GlobalMessage,
			FormInput
		},
		props: {
			submit: {
				type: Function,
				required: true
			},
			cancel: {
				type: Function,
				required: true
			},
			email: {
				type: String,
				required: true
			}
		},
		data() {
			return {
				isLoading: false,
				data: {
					email: this.email.toLowerCase(),
				},
				errors: {}
			}
		},
		methods: {
			onSubmit() {
				this.errors = this.validate(this.data);

				if (Object.keys(this.errors).length === 0) {
                    this.data.email = this.data.email.toLowerCase();
					this.isLoading = true;
					this.submit(this.data).catch(errors => {
                        this.isLoading = false;
                        this.errors = errors;

                        if (errors instanceof Error) {
                            // console.error(errors);
                        }
					});
				}
			},
			validate(data) {
				const errors = {};

				if (!data.email.length) {
					errors.email = 'This field is required';
				} else if (!isEmail(data.email)) {
					errors.email = 'Invalid email';
				}

				return errors;
			}
		}
	};
</script>
